export default __webpack_public_path__ + "static/media/Spectrometer.e0806929.jpg";